import { render, staticRenderFns } from "./DiscountCreate.vue?vue&type=template&id=541e26e1"
import script from "./DiscountCreate.vue?vue&type=script&lang=js"
export * from "./DiscountCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports